import { Box, IconButton, InputBase } from "@mui/material";
import classes from "./SearchBar.module.scss";
import SearchIcon from '@mui/icons-material/Search';
import { KeyboardEvent, useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { setHasWords } from "../../../store/filters/filters.slice";
import { useNavigate } from 'react-router-dom';
import { setTipsHasWords } from "../../../store/filters/tipFilters.slice";

const SearchBar = () => {
  const [searchValue, setSearchValue] = useState<string>('');
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSearch = useCallback(() => {
    const keywords = searchValue.trim() ? searchValue.trim() : null;
    dispatch(setTipsHasWords(keywords));
    dispatch(setHasWords(keywords));

    if (keywords) {
        navigate('/');
    }
  }, [dispatch, navigate, searchValue]);

  const handleSearchKeyDown = (event: KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if ('Enter' === event.key) {
      event.preventDefault();
      handleSearch();
    }
  };

  return (
    <Box className={`d-flex`}>
      <Box className={`${classes.search} d-flex align-items-center me-1`} component="form">
        <InputBase
          className='mx-1 flex-grow-1'
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          placeholder='Search by keywords'
          onKeyDown={handleSearchKeyDown}
        />
      </Box>
      <IconButton type='button' aria-label='search' className={classes.searchButton} onClick={handleSearch}>
        <SearchIcon className={classes.searchIcon} />
      </IconButton>
    </Box>
  )
};

export default SearchBar
